module.exports = __webpack_public_path__ + "img/search-engine.033ce842.svg";